import request from '@/utils/request'

// 服务地点列表
export const listServiceLocation = (pageData, formData) => {
    return request.get(`/serviceLocation/page/${pageData.page}/${pageData.pageSize}`, {params: formData})
}
// 新增服务地点
export const addServiceLocation = (formData) => {
    return request.post('/serviceLocation', formData)
}
//  服务地点详情
export const detailServiceLocation = (id) => {
    return request.get(`/serviceLocation/${id}`)
}
//  修改服务地点
export const editServiceLocation = (updateData) => {
    return request.put('/serviceLocation', updateData)
}
